import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { ResourceId } from '®shared/annotations/study-note/study-note';

import {
  ALL_READING_INTENTIONS,
  READING_INTENTIONS,
  ReadingIntention,
  ReadingIntentionsKey,
  SaveableReadingIntention,
} from './reading-intention';

type ReadingIntentionUpdate = { status: string; resource: string };

// TODO: fix the "SaveableReadingIntention not found" error when this is removed.
type SaveableReadingIntentionAliased = SaveableReadingIntention;

@Component({
  selector: 'rl-reading-intentions-menu',
  templateUrl: './reading-intentions-menu.component.html',
})
export class ReadingIntentionsMenuComponent implements OnChanges {
  ReadingIntentionsKey = ReadingIntentionsKey;

  @Input() resourceId: string;
  @Input() areAnnotationsResolved: boolean;
  @Input() readingIntention?: SaveableReadingIntentionAliased;
  @Input() canUpdateReadingIntention: boolean;

  @Output()
  readingIntentionDelete: EventEmitter<ResourceId> = new EventEmitter();
  @Output()
  readingIntentionUpdate: EventEmitter<ReadingIntentionUpdate> =
    new EventEmitter();

  public intentions: ReadingIntention[] = ALL_READING_INTENTIONS;

  intention: ReadingIntention;

  ngOnChanges() {
    this.intention =
      this.readingIntention && !this.readingIntention.isDeleting
        ? READING_INTENTIONS[this.readingIntention.status]
        : READING_INTENTIONS.Undecided;

    const hasReadingIntention = this.readingIntention ? true : false;
    const hasUpdateableReadingIntention =
      hasReadingIntention &&
      this.readingIntention.isDeleting !== true &&
      this.readingIntention.isSaving !== true;

    this.canUpdateReadingIntention =
      this.areAnnotationsResolved &&
      (!hasReadingIntention || hasUpdateableReadingIntention);
  }

  /**
   * Updates the underlying state of the reading intention when it is changed.
   *
   * For UNDECIDED values, we delete the reading intention;
   * for all other intention values, we update the intention.
   * @param intention: ReadingIntention - the chosen intention
   **/
  onReadingIntentionChange(intention: ReadingIntention) {
    if (intention === READING_INTENTIONS.Undecided) {
      this.readingIntentionDelete.emit({ resource: this.resourceId });
    } else {
      this.readingIntentionUpdate.emit({
        status: intention.value,
        resource: this.resourceId,
      });
    }
  }
}
